import React, { useState, useEffect } from "reactn"
import { Seo } from "./seo"
import { ProductSEO } from "./search/productSeo";
import ProductPage from "./productInfo/productPage"
import DataLayer from "./dataLayer";

export default function Product({
    location,
    globalState,
    data: { staticProduct, shipping, productInformation, upcycleShipping }
}) {

    const {
        handle,
        tags
    } = staticProduct

    const [searchHit, setSearchHit] = useState(false);
    const [searchQueryID, setSearchQueryID] = useState("");
    const [collection, setCollection] = useState("");
    const [collectionURL, setCollectionURL] = useState("");
    const [itemLocation, setItemLocation] = useState(0);
    const [searchObjectID, setSearchObjectID] = useState("null");
    const [sendData, setSendData] = useState(false)

    useEffect(() => {
        if (location.state && location.state.queryID) {
            setSearchHit(true)
            setCollection(location.state.list)
            setCollectionURL(location.state.collectionURL)
            setItemLocation(location.state.itemLocation)
            setSearchQueryID(location.state.queryID)
            setSearchObjectID(location.state.objectID)
            setSendData(true)
        } else {
            setSearchHit(false)
            setSearchQueryID("")
            setCollection("")
            setItemLocation(0)
            setCollectionURL("")
            setSearchObjectID("")
            setSendData(true)
        }
    }, [location])

    const metafields = staticProduct.metafields.find(metafield => metafield.fields.gender != null)?.fields || {};
    // let metafields = staticProduct.metafields[0] ? staticProduct.metafields[0].fields : []
    // for (let i = 1; i < staticProduct.metafields.length; i++) {
    //     metafields =  {...staticProduct.metafields[0].fields, ...staticProduct.metafields[i].fields}
    // }

    const {
        meta_title,
        meta_description,
        own_garment,
        social_images,
    } = metafields

    const shippingTouse = own_garment ? upcycleShipping : shipping
    // console.log("GA4XXX". staticProduct)
    return (
        <>
            {sendData &&
                <>
                    <DataLayer
                        product={staticProduct}
                        list={collection}
                        location={location}
                        itemLocation={itemLocation}
                        metafields={metafields}
                    />
                </>
            }
            <Seo metaTitle={meta_title} metaDescription={meta_description} productImage={handle} og_type={'product'} location={location} />
            <ProductSEO location={location} product={staticProduct} metafields={metafields} socialImages={social_images} />
            <ProductPage
                globalState={globalState}
                searchHit={searchHit}
                collection={collection}
                itemLocation={itemLocation}
                isDesign = {tags.includes("design-your-own")}
                isGarment = {tags.includes("design-your-own-garment")}
                searchObjectID={searchObjectID}
                searchQueryID={searchQueryID}
                product={staticProduct} productMetafields={metafields} shipping={shippingTouse} productInformation={productInformation} />
        </>
    )
}


